<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ organization.name }} - {{ $t("COMMON.USERS") }}</h3>
    <user-list-table :filterOrganization="organization.id" />
  </div>
</template>

<script>
import UserListTable from "../../UserManagement/partials/UserListTable.vue";
export default {
  name: "organization-view-users",

  components: { UserListTable },

  props: ["organization"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    organization(organization) {},
  },
};
</script>
